import { attributes, type } from "@type-r/models";
import moment from "moment";

export type DestinationTarget = InstanceType<typeof DestinationTarget>;

export const DestinationTarget = attributes({
    isEnabled: type(Boolean).value(true),
    platform: String,
    product: String,
    assetTypeId: Number,
    facilities: [],
    program: { id: Number, name: String }
});

export type ImportDetails = InstanceType<typeof ImportDetails>;

export const ImportDetails = attributes({
    assetType: String,
    dataFormat: String,
    isDefault: type(Boolean),
    createdOn: type(Date)
});

export type DirectoryPath = InstanceType<typeof DirectoryPath>;

export const DirectoryPath = attributes({
    uniqueIndex: String,
    isActive: Boolean,
    path: String,
    emailFrom: String,
    modifyExistingAssets: Boolean,
    mergeExistingAssets: Boolean,
    importTemplateId: type(String)
        .check(function () { return this.useStandardMapping || this.importTemplateId }, 'Required'),
    useStandardMapping: type(Boolean),
    importDetails: type(ImportDetails),
    destinationTargets: type([DestinationTarget]).value([{ isEnabled: true, platform: '', product: '', assetTypeId: 1 }]),
    fileCode: type(String).required,
    frequency: type(String).required.check(value => {
        const time = value.split(':');
        const isValidDate = moment(value, 'hh:mm').isValid();
        const date = moment().set({ hour: time[0], minute: time[1] });
        const start = moment().set({ hour: 0, minute: 1 });
        const isAfter = date.isAfter(start);
        return isValidDate && isAfter
    }),
});

export type ConnectionSettingsDTO = InstanceType<typeof ConnectionSettingsDTO>;

export const ConnectionSettingsDTO = attributes({
    serverName: type(String),
    host: type(String),
    port: type(Number).value(22),
    userName: type(String),
    password: type(String),
    paths: [DirectoryPath]
});
